<template>

    <div class="sdev-wizard-step">

        <h2>{{ step }}</h2>

        <form @submit.prevent="submit">

            <div v-for="f in fields" :key="f.name" class="sdev-form-field">

                <label class="sdev-form-label">
                    {{ f.name }}
                </label>

                <input v-if="f.type === 'text'" v-model="form[f.name]" class="sdev-input" />

                <input v-if="f.type === 'password'" v-model="form[f.name]" type="password" class="sdev-input" />

            </div>

            <button class="sdev-button">
                Next
            </button>

        </form>

    </div>

</template>